import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

@Pipe({
  name: 'changeTimezone',
})

// TO SHOW TIME INFORMATION FROM THIS PIPE DATABASE BY TIMEZONE
// BU PIPE VERİTABANINDAN GELEN ZAMAN BİLGİSİNİN SAATİNİ TİMEZONE'A GÖRE GÖSTERMEK İÇİN
// 2023-03-06T08:00:00Z >>>>> 2023-03-06T11:00:00+03:00
export class changeTimezone implements PipeTransform {
  transform(
    dateString: string | Date,
    timezone: string,
    format?: string
  ): string {
    if (!timezone) {
      timezone = 'Etc/GMT-0';
    }

    const d2 = dayjs.utc(dateString).tz(timezone);

    if (format) {
      return d2.format(format);
    } else {
      return d2.format('HH:mm');
    }
  }
}
